import React from 'react';
import PalmettoAuthV2 from './components/auth/PalmettoAuthV2';

const AppShell = () => {
    return <PalmettoAuthV2 />;
};

export default AppShell;
